import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type ComboPreviewType } from '@/defs/combo'
import { formatFullNumber, formatSigFig } from '@/utils/formatUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'

type Props = {
  combo: ComboPreviewType
}

export const StatComboDeckTotal = ({ combo }: Props) => {
  const popover = (
    <>
      <h2>
        <IconWithLabel iconBefore='layerGroup'>Deck Total</IconWithLabel>
      </h2>
      <p>
        This combo is in <strong>{formatFullNumber(combo.numDecks)}</strong> total decks.
      </p>
    </>
  )

  return (
    <StatCommonBox label='Decks' popover={popover}>
      <StatCommonFigure>{formatSigFig(combo.numDecks)}</StatCommonFigure>
    </StatCommonBox>
  )
}
